import ButtonBase from "@material-ui/core/ButtonBase";
import { withStyles } from "@material-ui/core/styles";
import React, { FC, ReactElement } from "react";
import { NavLink } from "react-router-dom";
import { styles } from "./styles";
import { ISidebarPropsWithStyles } from "./types";
import { Box, Tooltip } from "@material-ui/core";

const SideBarLink: FC<ISidebarPropsWithStyles> = ({
  action,
  classes,
  title,
  icon,
  to,
  className,
  externalLink,
  target,
  isSidebarOpen = false,
  tooltipTitle,
}: ISidebarPropsWithStyles) => {
  const alignmentClass = isSidebarOpen ? classes.left : classes.center;

  const TooltipHOC = ({
    children,
    text,
  }: {
    children: ReactElement;
    text: string;
  }) => (
    <Tooltip title={text} placement="right">
      <Box>{children}</Box>
    </Tooltip>
  );

  const Content = () => {
    return (
      <>
        {icon}
        {isSidebarOpen && title && (
          <Box key="text" className={classes.text}>
            {title.toUpperCase()}
          </Box>
        )}
      </>
    );
  };

  const ExternalLink = () => (
    <a
      href={externalLink}
      target={target}
      className={`${alignmentClass} ${classes.link} ${className}`}
    >
      <Content />
    </a>
  );

  const InternalLink = () => (
    <NavLink
      className={`${alignmentClass} ${classes.link} ${className}`}
      activeClassName={classes.activeLink}
      // okay to type cast since only rendered when `to` is truthy (below)
      to={to as string}
      target={target}
    >
      <Content />
    </NavLink>
  );

  const SidebarButton = () => {
    return (
      <ButtonBase
        className={`${alignmentClass} ${classes.sidebarButton} ${classes.link} ${className} ${classes.buttonLink}`}
        onClick={action}
      >
        <Content />
      </ButtonBase>
    );
  };

  if (!!externalLink) {
    return tooltipTitle && !isSidebarOpen ? (
      <TooltipHOC text={tooltipTitle}>
        <ExternalLink />
      </TooltipHOC>
    ) : (
      <ExternalLink />
    );
  }

  if (to) {
    return tooltipTitle && !isSidebarOpen ? (
      <TooltipHOC text={tooltipTitle}>
        <InternalLink />
      </TooltipHOC>
    ) : (
      <InternalLink />
    );
  }

  return tooltipTitle && !isSidebarOpen ? (
    <TooltipHOC text={tooltipTitle}>
      <SidebarButton />
    </TooltipHOC>
  ) : (
    <SidebarButton />
  );
};

export default withStyles(styles)(SideBarLink);



// WEBPACK FOOTER //
// ./src/shared/components/sidebar/components/SidebarLink/SidebarLink.tsx